

import AddHandleLettersOldPage from './AddHandleLettersOldPage.jsx';
import HandleLettersOldPage from './HandleLettersOldPage.jsx';
import ThuHoiXuLyDonOldPage from './ThuHoiXuLyDonOldPage.jsx';

export {
  AddHandleLettersOldPage,
  HandleLettersOldPage,
  ThuHoiXuLyDonOldPage
};



// WEBPACK FOOTER //
// ./src/components/pages/handle-letters-old/index.js